import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Swal from 'sweetalert2';
// import { designation, onboardEmployeeOnHRMS } from '../../action/hrms';
import { UpdateJobResponse, updateStatus } from '../../action/jobs';
import { onChange, validateForm } from '../../utils';
class HaveHRMS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: { name: 'Name', value: '', error: '', isRequired: true },
            Mobile: { name: 'Mobile', value: '', error: '', isRequired: true },
            Email: { name: 'Email', value: '', error: '', isRequired: true },
            Role: { name: 'Role', value: '', error: '', isRequired: true },
            EmployeeCode: { name: 'EmployeeCode', value: '', error: '', isRequired: true },
            Designation: { name: 'Designation', value: '', error: '', isRequired: true },
            Department: { name: 'Department', value: '', error: '', isRequired: true },
            WorkLocation: { name: 'WorkLocation', value: '', error: '', isRequired: true },
            EmploymentType: { name: 'EmploymentType', value: '', error: '', isRequired: true },
            Shift: { name: 'Shift', value: '', error: '', isRequired: true },
            DateOfJoining: { name: 'DateOfJoining', value: '', error: '', isRequired: true },
            employee: { name: 'employee', value: '', error: '', isRequired: true }

        }
    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }

    render() {
        const {
            Name,
            Mobile,
            Email,
            Role,
            EmployeeCode, employee, Designation, Department, WorkLocation, EmploymentType, Shift, DateOfJoining,

        } = this.state

        const { role, designation, employementType, location, department, shift, reportingaManager, } = this.props
        console.log(this.props)
        return (
            <React.Fragment>
                <form onSubmit={(e) => { this.onSubmit(e) }}>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Name *</label>
                                <div className="form-group">
                                    <input
                                        className={Name.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'text'}
                                        name={Name.name}
                                        value={Name.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Name" />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Email *</label>
                                <div className="form-group">
                                    <input
                                        className={Email.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'text'}
                                        name={Email.name}
                                        value={Email.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Email" />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Mobile *</label>
                                <div className="form-group">
                                    <input
                                        className={Mobile.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'text'}
                                        name={Mobile.name}
                                        value={Mobile.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Mobile Number"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Role *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={Role.error.length ? "form-control is-invalid" : "form-control"}

                                        name={Role.name}
                                        value={Role.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Name" >
                                        <option value="">Select Role</option>
                                        {role && role.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Employee Code *</label>
                                <div className="form-group">
                                    <input
                                        className={EmployeeCode.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'text'}
                                        name={EmployeeCode.name}
                                        value={EmployeeCode.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Employee Code" />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Designation *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={Designation.error.length ? "form-control is-invalid" : "form-control"}
                                        name={Designation.name}
                                        value={Designation.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Designation</option>
                                        {designation && designation.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Department *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={Department.error.length ? "form-control is-invalid" : "form-control"}
                                        name={Department.name}
                                        value={Department.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Department</option>
                                        {department && department.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Work Location *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={WorkLocation.error.length ? "form-control is-invalid" : "form-control"}
                                        name={WorkLocation.name}
                                        value={WorkLocation.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Work Location</option>
                                        {location && location.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Employement Type *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={EmploymentType.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'text'}
                                        name={EmploymentType.name}
                                        value={EmploymentType.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Employement Type</option>

                                        {employementType && employementType.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Shift *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={Shift.error.length ? "form-control is-invalid" : "form-control"}
                                        name={Shift.name}
                                        value={Shift.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Shift</option>
                                        {shift && shift.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Date of Joining *</label>
                                <div className="form-group">
                                    <input id='fristoption'
                                        className={DateOfJoining.error.length ? "form-control is-invalid" : "form-control"}
                                        type={'date'}
                                        name={DateOfJoining.name}
                                        value={DateOfJoining.value}
                                        onChange={this.onChange}
                                        placeholder="Enter Name" />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="input-box havehrms">
                                <label className="label-text">Reporting Manager *</label>
                                <div className="form-group">
                                    <select id='fristoption'
                                        className={employee.error.length ? "form-control is-invalid" : "form-control"}
                                        name={employee.name}
                                        value={employee.value}
                                        onChange={this.onChange}
                                    >
                                        <option value=''>Select Shift</option>
                                        {reportingaManager && reportingaManager.map(i => {
                                            return (<option value={i.id}>{i.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12 text-right'>
                            <button type='submit' className='btn btn-danger' onSubmit={(e) => { this.onSubmit(e) }}>OnBoard</button>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        )
    }

    onSubmit = (e) => {
        debugger
        e.preventDefault();
        if (validateForm(this)) {
            const { Name,
                Mobile,
                Email,
                Role,
                EmployeeCode, employee, Designation, Department, WorkLocation, EmploymentType, Shift, DateOfJoining, } = this.state
            const model = {
                name: Name.value,
                email: Email.value,
                mobile: Mobile.value,
                roleId: Role.value,
                employeeId: EmployeeCode.value,
                employmentTypeId: EmploymentType.value,
                designationId: Designation.value,
                departmentId: Department.value,
                workLocationId: WorkLocation.value,
                dateOfJoining: DateOfJoining.value,
                reportingManagerId: employee.value,
                shiftId: Shift.value,
                org_id: this.props.org_id
            }
            console.log(model)
            // onboardEmployeeOnHRMS(model).then(res => {
            //     if (res.status) {

            //         UpdateJobResponse({ JOB_ID: this.props.JOB_ID, CANDIDATE_ID: this.props.CANDIDATE_ID, STATUS_ID: 11 }).then(res => {
            //             if (res.status) {
            //                 Swal.fire({
            //                     text: 'Candidate Successfully Onboarded in HRMS',
            //                     icon: 'success'
            //                 }).then(res => {
            //                     window.location.reload()
            //                 })
            //             }
            //         }).catch(err => {
            //             console.log(err)
            //         })

            //     }
            //     else {
            //         Swal.fire({
            //             icon: "error",
            //             text: res.error,
            //             timer: 1500,
            //             showCancelButton: false,
            //             showConfirmButton: false,
            //         });
            //     }
            // }
            // )
        }
    }

}

export default (HaveHRMS)